module.exports = __webpack_public_path__ + "static/media/task3Planet2.32cb24cf.png";